import Papa from 'papaparse'

export const JSONtoCSV = (input: Record<string, any>[] | any[][]) => {
  return Papa.unparse(input)
}
